import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M7.628 8.485c1.755 0 3.178 1.357 3.178 3.03v1.212c0 .335-.284.606-.635.606-.352 0-.636-.271-.636-.606v-1.212c0-1.004-.854-1.818-1.907-1.818h-4.45c-1.053 0-1.907.814-1.907 1.818v1.212c0 .335-.284.606-.635.606-.351 0-.636-.271-.636-.606v-1.212c0-1.673 1.423-3.03 3.178-3.03zm5.085-4.243c.351 0 .636.272.636.606l-.001 1.212h1.272c.32 0 .584.225.629.517l.007.09c0 .334-.285.606-.636.606h-1.272v1.212c0 .304-.234.556-.54.6l-.095.006c-.35 0-.635-.271-.635-.606l-.001-1.213h-1.27c-.32 0-.584-.224-.63-.516l-.006-.09c0-.334.284-.605.635-.605h1.271V4.847c0-.304.236-.556.542-.599zm-7.31-3.03c1.755 0 3.178 1.357 3.178 3.03 0 1.674-1.423 3.03-3.178 3.03s-3.178-1.356-3.178-3.03c0-1.673 1.423-3.03 3.178-3.03zm0 1.212c-1.053 0-1.907.814-1.907 1.818 0 1.005.854 1.819 1.907 1.819S7.31 5.247 7.31 4.242c0-1.004-.854-1.818-1.907-1.818z",
			transform: "translate(-1195 -668) translate(1180 656) translate(15.256 12.727)"
		}) }) }) })
	})
});
export default SvgUserPlus;
